import { useEffect } from "react";
import { axiosPrivate } from "../api/axiosCustom";
import useRefreshToken from "./useRefreshToken";

const useAxiosPrivate = () => {
  const refresh = useRefreshToken();
  useEffect(() => {
    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (
          error?.response?.status === 401 &&
          !prevRequest?.sent &&
          !prevRequest?.url?.includes("/auth/logout/")
        ) {
          prevRequest.sent = true;
          const refreshed = await refresh();
          if (refreshed) return axiosPrivate(prevRequest);
        }
        return Promise.reject(error);
      }
    );
    return () => axiosPrivate.interceptors.response.eject(responseIntercept);
  }, [refresh]);

  return axiosPrivate;
};

export default useAxiosPrivate;
